import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { RootStackParamList } from './types';

import Login from '../pages/Login';

// Driver
import DashboardDriver from '../pages/Driver/Dashboard';
import ReportProblem from '../pages/Driver/ReportProblem';
import ViewProblem from '../pages/Driver/ViewProblem';
import ConfirmDelivery from '../pages/Driver/ConfirmDelivery';
import NewRouteDriver from '../pages/Driver/AddRoute/NewRoute';
import ListRoutesDriver from '../pages/Driver/AddRoute/ListRoutes';
import SelectDriverDriver from '../pages/Driver/AddRoute/SelectDriver';

// Admin
import ReportAdmin from '../pages/Admin/Report';
import RouteAdmin from '../pages/Admin/Route';
import DriversAdmin from '../pages/Admin/Drivers';
import ClientsAdmin from '../pages/Admin/Clients';
import SelectDriverAdmin from '../pages/Admin/AddRoute/SelectDriver';
import AddDriverAdmin from '../pages/Admin/AddDriver';
import AddClientAdmin from '../pages/Admin/AddClient';
import DetailsDeliveryAdmin from '../pages/Admin/DetailsDelivery';
import ListRoutesAdmin from '../pages/Admin/AddRoute/ListRoutes';
import NewRouteAdmin from '../pages/Admin/AddRoute/NewRoute';

// Loading
import Loading from '../pages/Loading';

// Change Password
import ChangePassword from '../pages/ChangePassword';

// Profile
import Profile from '../pages/Profile';
import UpdateProfile from '../pages/UpdateProfile';

// Recovery password
import RecoveryPassword from '../pages/RecoveryPassword';

// Success
import Success from '../pages/Success';

//contexts
import { UserProvider } from '../context/user';
import { RegisterDriverProvider } from '../context/registerDriver';
import { RouteProvider } from '../context/route';
import { ClientProvider } from '../context/client';

const { Navigator, Screen } = createStackNavigator<RootStackParamList>();

function Routes() {
    return (
        <NavigationContainer>
            <UserProvider>
                <RegisterDriverProvider>
                    <RouteProvider>
                        <ClientProvider>
                            <Navigator screenOptions={{ headerShown: false }}>
                                <Screen name="Loading" component={Loading} />
                                <Screen name="Login" component={Login} />
                                <Screen name="RecoveryPassword" component={RecoveryPassword} />
                                <Screen name="ChangePassword" component={ChangePassword} />
                                <Screen name="DashboardDriver" component={DashboardDriver} />
                                <Screen name="ReportProblemDriver" component={ReportProblem} />
                                <Screen name="ViewProblemDriver" component={ViewProblem} />
                                <Screen name="NewRouteDriver" component={NewRouteDriver} />
                                <Screen name="ListRoutesDriver" component={ListRoutesDriver} />
                                <Screen name="SelectDriverDriver" component={SelectDriverDriver} />
                                <Screen name="Profile" component={Profile} />
                                <Screen name="UpdateProfile" component={UpdateProfile} />
                                <Screen name="ConfirmDeliveryDriver" component={ConfirmDelivery} />
                                <Screen name="ReportAdmin" component={ReportAdmin} />
                                <Screen name="RouteAdmin" component={RouteAdmin} />
                                <Screen name="DriversAdmin" component={DriversAdmin} />
                                <Screen name="ClientsAdmin" component={ClientsAdmin} />
                                <Screen name="SelectDriverAdmin" component={SelectDriverAdmin} />
                                <Screen name="ListRoutesAdmin" component={ListRoutesAdmin} />
                                <Screen name="NewRouteAdmin" component={NewRouteAdmin} />
                                <Screen name="AddDriverAdmin" component={AddDriverAdmin} />
                                <Screen name="AddClientAdmin" component={AddClientAdmin} />
                                <Screen name="DetailsDeliveryAdmin" component={DetailsDeliveryAdmin} />
                                <Screen name="Success" component={Success} />
                            </Navigator>
                        </ClientProvider>
                    </RouteProvider>
                </RegisterDriverProvider>
            </UserProvider>
        </NavigationContainer>
    );
  }
  
  export default Routes;